<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="技术人员基本信息变更" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" style="padding:10px 20px;">
                            <a-row :gutter="[0, 6]">
                                <a-col :span="6">
                                    <a-form-item label="变更表编号">
                                        <a-input ref="bgsqbbh" v-model="editData.bgsqbbh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="变更日期" required>
                                        <a-date-picker ref="bgrq" v-model="editData.bgrq" valueFormat="YYYY-MM-DD" style="width:100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="姓名" required>
                                        <a-input-search ref="xm" readOnly @search="isShow_xm = true" v-model="editData.xm" />
                                        <FGDataSelect
                                            :isShow.sync="isShow_xm"
                                            selectNo="RY1001"
                                            :condition="selStaticCondition"
                                            @saveselect="saveEvent_xm(arguments, editData)"
                                        ></FGDataSelect>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <div class="image-container">
                                        <UploadImage :attachCfg="attachCfg_Edit" />
                                    </div>
                                </a-col>
                            </a-row>
                            <a-row :gutter="[0, 6]">
                                <a-col :span="6">
                                    <a-form-item label="性别" required>
                                        <FGDictSelectCN ref="xb" dictNo="RY100101" v-model="editData.xb" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="民族" required>
                                        <FGDictSelectCN ref="mz" dictNo="RY100102" v-model="editData.mz" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="出生日期" required>
                                        <a-date-picker ref="csrq" v-model="editData.csrq" valueFormat="YYYY-MM-DD" style="width:100%" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="[0, 6]">
                                <a-col :span="6">
                                    <a-form-item label="证件类型" required>
                                        <FGDictSelectCN ref="zjlx" dictNo="RY100104" v-model="editData.zjlx" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="证件号码" required>
                                        <a-input ref="zjhm" v-model="editData.zjhm" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="所属单位编号">
                                        <a-input-search ref="ssdwbh" readOnly @search="showSsdw" v-model="editData.ssdwbh" />
                                        <FGDataSelect
                                            :isShow.sync="isShow_ssdwbh"
                                            selectNo="CW100101"
                                            condition=" AND DWZT='启用' "
                                            @saveselect="saveEvent_ssdwbh(arguments, editData)"
                                        ></FGDataSelect>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="[0, 6]">
                                <a-col :span="6">
                                    <a-form-item label="所属单位名称">
                                        <a-input-search ref="ssdwmc" readOnly @search="showSsdw" v-model="editData.ssdwmc" />
                                        <FGDataSelect
                                            :isShow.sync="isShow_ssdwmc"
                                            selectNo="CW100101"
                                            condition=" AND DWZT='启用' "
                                            @saveselect="saveEvent_ssdwbh(arguments, editData)"
                                        ></FGDataSelect>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="区域编号">
                                        <a-input-search ref="qybh" readOnly @search="showQy" v-model="editData.qybh" />
                                        <FGDataSelect
                                            :isShow.sync="isShow_qybh"
                                            selectNo="JC100101T"
                                            @saveselect="saveEvent_qybh(arguments, editData)"
                                        ></FGDataSelect>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="区域名称">
                                        <a-input-search ref="qymc" readOnly @search="showQy" v-model="editData.qymc" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="[0, 6]">
                                <a-col :span="6">
                                    <a-form-item label="人员类别" required>
                                        <FGDictSelectCN ref="rylb" dictNo="RY100105" v-model="editData.rylb" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="职务">
                                        <a-input ref="zw" v-model="editData.zw" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="职称">
                                        <FGDictSelectCN ref="zc" dictNo="RY100109" v-model="editData.zc" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="[0, 6]">
                                <a-col :span="6">
                                    <a-form-item label="职称专业">
                                        <a-input ref="zczy" v-model="editData.zczy" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="批准时间">
                                        <a-date-picker ref="pzsj" v-model="editData.pzsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="毕业院校" required>
                                        <a-input ref="byyx" v-model="editData.byyx" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="毕业时间" required>
                                        <a-date-picker ref="bysj" v-model="editData.bysj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="所学专业" required>
                                        <a-input ref="sxzy" v-model="editData.sxzy" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="学历" required>
                                        <FGDictSelectCN ref="xl" dictNo="RY100106" v-model="editData.xl" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="学位" required>
                                        <FGDictSelectCN ref="xw" dictNo="RY100107" v-model="editData.xw" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="参加工作时间" required>
                                        <a-date-picker ref="cjgzsj" v-model="editData.cjgzsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="从业时间">
                                        <a-date-picker ref="cysj" v-model="editData.cysj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="固定电话">
                                        <a-input ref="gddh" v-model="editData.gddh" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="移动电话">
                                        <a-input ref="yddh" v-model="editData.yddh" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="个人简历">
                                        <a-input ref="grjl" v-model="editData.grjl" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="上岗证编号">
                                        <a-input ref="sgzbh" v-model="editData.sgzbh" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="变更说明" required>
                                        <a-input ref="bgsm" v-model="editData.bgsm" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="首次登记时间">
                                        <a-date-picker ref="sczcsj" v-model="editData.sczcsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="录入部门">
                                        <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="录入人">
                                        <a-input ref="lrrxm" v-model="editData.lrrxm" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="录入时间">
                                        <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="备注">
                                        <a-input ref="bz" v-model="editData.bz" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-form>
                        <!-- 操作日志 -->
                        <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachUpload :isnew="editData.isnew" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "JsrybgEdit",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            isnew: true,
            isShow_xm: false,
            isShow_ssdwbh: false,
            isShow_ssdwmc: false,
            isShow_qybh: false,
            isShow_qymc: false,
            selStaticCondition: "",
            tableData: [],
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
                this.operLogProps.visible = newVal;
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        attachCfg_Edit() {
            return {
                fktable: "ry_bgsqb",
                fkvalue: this.editDataId
            };
        },
        //附件参数
        attachCfg() {
            return {
                visible: false,
                fktable: "RY_BGSQB",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "RY3000"
            };
        }
    },
    activated() {
        if (!this.editDataId) {
            // 新增，设置默认值
            this.editData = {
                id: this.$FG_util.uuid(),
                isnew: true,
                bglx: "基本信息变更",
                bgsqbbh: "",
                bgrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                djlxid: "BGSQB",
                zjlx: "身份证",
                zczq: 3,
                bmid: this.getUserInfo.org_id,
                ryid: this.getUserInfo.personnel_id,
                yhid: this.getUserInfo.id,
                lrbmmc: this.getUserInfo.org_name,
                lrrxm: this.getUserInfo.personnel_name,
                lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                djzt: "制定"
            };
            this.$FG_helper.handleNewBillCode("BGSQBBH").then((val) => {
                this.editData.bgsqbbh = val;
            });
            this.editDataId = this.editData.id;
            this.tableData = [];
            this.submitShow = false;
        } else {
            this.submitShow = true;
            // 修改，加载数据
            this.loadData();
        }
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.bgrq.focus();
        });
    },
    mounted() {
        this.selStaticCondition = " AND SSDWID='" + this.getUserInfo.companyInfo.id + "' ";
    },
    methods: {
        showSsdw() {
            this.editData.ssdwid = null;
            this.editData.ssdwbh = null;
            this.editData.ssdwmc = null;
            this.isShow_ssdwbh = true;
        },
        showQy() {
            this.editData.qyid = null;
            this.editData.qybh = null;
            this.editData.qymc = null;
            this.isShow_qybh = true;
        },
        saveEvent_xm(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.jsryid = val[0][0].ID;
                this.editData.xm = val[0][0].XM;
                this.editData.xb = val[0][0].XB;
                this.editData.mz = val[0][0].MZ;
                this.editData.csrq = val[0][0].CSRQ;
                this.editData.zjlx = val[0][0].ZJLX;
                this.editData.zjhm = val[0][0].ZJHM;
                this.editData.ssdwid = val[0][0].SSDWID;
                this.editData.ssdwbh = val[0][0].SSDWBH;
                this.editData.ssdwmc = val[0][0].SSDWMC;
                this.editData.qyid = val[0][0].QYID;
                this.editData.qybh = val[0][0].QYBH;
                this.editData.qymc = val[0][0].QYMC;
                this.editData.rylb = val[0][0].RYLB;
                this.editData.zw = val[0][0].ZW;
                this.editData.zc = val[0][0].ZC;
                this.editData.zczy = val[0][0].ZCZY;
                this.editData.pzsj = val[0][0].PZSJ;
                this.editData.byyx = val[0][0].BYYX;
                this.editData.bysj = val[0][0].BYSJ;
                this.editData.sxzy = val[0][0].SXZY;
                this.editData.xl = val[0][0].XL;
                this.editData.xw = val[0][0].XW;
                this.editData.cjgzsj = val[0][0].CJGZSJ;
                this.editData.cysj = val[0][0].CYSJ;
                this.editData.gddh = val[0][0].GDDH;
                this.editData.yddh = val[0][0].YDDH;
                this.editData.grjl = val[0][0].GRJL;
                this.editData.sgzbh = val[0][0].SGZBH;
                this.editData.sczcsj = val[0][0].SCZCSJ;
                this.editData.zczt = val[0][0].ZCZT;

                this.copyImage(val[0][0].ID);
            }
        },
        saveEvent_qybh(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.qyid = val[0][0].ID;
                this.editData.qymc = val[0][0].QYMC;
                this.editData.qybh = val[0][0].QYBH;
            }
        },
        saveEvent_ssdwbh(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.ssdwid = val[0][0].ID;
                this.editData.ssdwbh = val[0][0].DWBH;
                this.editData.ssdwmc = val[0][0].DWMC;
            }
        },
        copyImage(id) {
            this.editDataId = "";
            this.$FG_http
                .post(
                    "./api/main/jsry/jsrybg/copyImage",
                    {
                        ryid: id,
                        djid: this.editData.id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 刷新
                        this.editDataId = this.editData.id;
                    }
                });
        },
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsrybg/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        },
        //提交form
        onSave(btnType) {
            // 表单校验
            if (btnType === 1) {
                if (!this.editData.bgrq) {
                    this.$FG_message.error("P0001", "变更日期").then(() => this.$refs.bgrq.focus());
                    return;
                }
                if (!this.editData.xm) {
                    this.$FG_message.error("P0001", "姓名").then(() => this.$refs.xm.focus());
                    return;
                }
                if (!this.editData.xb) {
                    this.$FG_message.error("P0001", "性别").then(() => this.$refs.xb.focus());
                    return;
                }
                if (!this.editData.mz) {
                    this.$FG_message.error("P0001", "民族").then(() => this.$refs.mz.focus());
                    return;
                }
                if (!this.editData.csrq) {
                    this.$FG_message.error("P0001", "出生日期").then(() => this.$refs.csrq.focus());
                    return;
                }
                if (!this.editData.zjlx) {
                    this.$FG_message.error("P0001", "证件类型").then(() => this.$refs.zjlx.focus());
                    return;
                }
                if (!this.editData.zjhm) {
                    this.$FG_message.error("P0001", "证件号码").then(() => this.$refs.zjhm.focus());
                    return;
                }
                if (!this.editData.rylb) {
                    this.$FG_message.error("P0001", "人员类别").then(() => this.$refs.rylb.focus());
                    return;
                }
                if (!this.editData.byyx) {
                    this.$FG_message.error("P0001", "毕业院校").then(() => this.$refs.byyx.focus());
                    return;
                }
                if (!this.editData.bysj) {
                    this.$FG_message.error("P0001", "毕业时间").then(() => this.$refs.bysj.focus());
                    return;
                }
                if (!this.editData.sxzy) {
                    this.$FG_message.error("P0001", "所学专业").then(() => this.$refs.sxzy.focus());
                    return;
                }
                if (!this.editData.xl) {
                    this.$FG_message.error("P0001", "学历").then(() => this.$refs.xl.focus());
                    return;
                }
                if (!this.editData.cjgzsj) {
                    this.$FG_message.error("P0001", "参加工作时间").then(() => this.$refs.cjgzsj.focus());
                    return;
                }
                if (!this.editData.bgsm) {
                    this.$FG_message.error("P0001", "变更说明").then(() => this.$refs.bgsm.focus());
                    return;
                }
                if (this.editData.csrq >= this.$FG_util.formatDate(new Date(), "YYYY-MM-DD")) {
                    this.$FG_message.error("RY200005", "出生日期").then(() => this.$refs.csrq.focus());
                    return;
                }
            }
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsrybg/save",
                    {
                        data: this.editData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        this.isnew = false;
                        if (btnType === 1) {
                            this.submit();
                        }
                    } else {
                        this.$refs.bgrq.focus();
                    }
                });
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/jsry/jsrybg/submit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.bgrq.focus();
                            }
                        });
                }
            });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = false;
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
